import { Injectable } from '@angular/core';
import { Config } from '../config';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HotparkingService {

  constructor(
    private config: Config,
    private http: HttpClient
  ) { }

  getPermittedCompanies(): Observable<any[]> {
    return this.http.get<any[]>(this.config.get('API_SERVER_URL') + '/hotparking/companies');
  }

  addHotParkingCard(idCarparkUser: number): Observable<HttpResponse<void>> {
    return this.http.put<HttpResponse<void>>(this.config.get('API_SERVER_URL') + '/hotparking/card', idCarparkUser);
  }

  addPubHotParkingCard(serialNumber: string, licensePlate: string): Observable<HttpResponse<void>> {
    let params = {
      cardSerialNumber: serialNumber,
      licensePlate: licensePlate
    };
    return this.http.put<HttpResponse<void>>(this.config.get('API_SERVER_URL') + '/pub/hotparking/card', params);
  }

  deleteHotParkingCard(idHotParkingPosition: number): Observable<HttpResponse<void>> {
    return this.http.delete<HttpResponse<void>>(this.config.get('API_SERVER_URL') + `/hotparking/card/${idHotParkingPosition}`);
  }

  deletePubHotParkingCard(serialNumber: string, licensePlate: string): Observable<HttpResponse<void>> {
    let params = {
      cardSerialNumber: serialNumber,
      licensePlate: licensePlate
    }
    return this.http.post<HttpResponse<void>>(this.config.get('API_SERVER_URL') + '/pub/hotparking/card', params);
  }

  getHotParkingList(idCompany: number): Observable<any[]> {
    return this.http.get<any[]>(this.config.get('API_SERVER_URL') + `/hotparking/card/list/${idCompany}`);
  }
}
